/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Profile_Api_Keys_Empty_DescriptionInputs */

const es_user_profile_api_keys_empty_description = /** @type {(inputs: User_Profile_Api_Keys_Empty_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creá una clave API para habilitar integraciones`)
};

const en_user_profile_api_keys_empty_description = /** @type {(inputs: User_Profile_Api_Keys_Empty_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create an API key to enable integrations`)
};

/**
* | output |
* | --- |
* | "Create an API key to enable integrations" |
*
* @param {User_Profile_Api_Keys_Empty_DescriptionInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const user_profile_api_keys_empty_description = /** @type {((inputs?: User_Profile_Api_Keys_Empty_DescriptionInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Profile_Api_Keys_Empty_DescriptionInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_user_profile_api_keys_empty_description(inputs)
	return en_user_profile_api_keys_empty_description(inputs)
});
export { user_profile_api_keys_empty_description as "user.profile.api_keys.empty.description" }